export enum SchedulerTab {
  ScheduledActions = 'scheduled-actions',
  Templates = 'templates',
}
